export default {
	idToEntity: function(entities) {
		return entities.reduce((map, entity) => map.set(entity.id, entity), new Map());
	}
}


// WEBPACK FOOTER //
// ./src/utils/store.js